import {
  faCommentAltLines,
  faFileCertificate
} from '@fortawesome/pro-light-svg-icons';

import { OpenDuty, PlannedDuty } from './types';

import { FontAwesomeSvgIcon } from 'components/shared';

import {
  hasIcons as hasOpenRequestIcons,
  OpenRequestDutyIcons
} from './OpenRequestDuty/OpenRequestDuty';

export default function DutyIcons(duty: PlannedDuty | OpenDuty) {
  const { notes = [], qualifications } = duty;
  const validNotes = notes.filter(({ text }) => text?.trim());
  const hasNotes = Boolean(validNotes.length);
  const hasQualifications = Boolean(qualifications && qualifications.length);
  const isOpenRequestAndHasIcons = Boolean(
    duty.isOpen && hasOpenRequestIcons(duty)
  );
  const hasIcons = hasNotes || hasQualifications || isOpenRequestAndHasIcons;

  if (hasIcons) {
    return (
      <div className="icons">
        {hasNotes && (
          <FontAwesomeSvgIcon icon={faCommentAltLines} fontSize="small" />
        )}
        {duty.isOpen && isOpenRequestAndHasIcons && (
          <OpenRequestDutyIcons {...duty} />
        )}
        {hasQualifications && (
          <FontAwesomeSvgIcon icon={faFileCertificate} fontSize="small" />
        )}
      </div>
    );
  }

  return <></>;
}
